import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { IGenericResponse, ResponseStatus } from '../../shared';
import { SelectItem } from '../../shared/efaact-primeng.module';
import { LoadingService } from '../../shared/loading';
import { LoggingService } from '../../shared/services/logging/logging.service';
import * as fromRoot from '../../store';
import { AccountAllocation, FacilityAllocation } from './store';
import { AccountPostingType } from './store/account-posting-type.model';

@Injectable({
    providedIn: 'root'
})
export class AccountAllocationsService extends LoadingService {
    private uri = `${environment.apiLocation}/AccountAllocation`;
    private facilityAllocationsUri = `${environment.apiLocation}/FacilityAllocation`;
    private facilityAllocationTypeUri = `${environment.apiLocation}/FacilityAllocationType`;
    private accountPostingTypeUri = `${environment.apiLocation}/AccountPostingType`;

    constructor(
        private http: HttpClient,
        protected log: LoggingService,
        protected rootStore: Store<fromRoot.CoreState>
    ) {
        super(rootStore);
    }

    get(): Observable<AccountAllocation[]> {
        return this.http.get<AccountAllocation[]>(this.uri).pipe(
            map(res =>
                res.map(x => ({
                    ...x,
                    id: x.Accountlistid,
                    Status: {
                        StatusCode: x && x.Status ? x.Status.StatusCode : 0,
                        Message: x && x.Status ? x.Status.Message : '',
                        MsgEntityID:
                            x && x.Status
                                ? x.Status.MsgEntityID
                                : x.Accountlistid
                    }
                }))
            )
        );
    }
    put(
        accountAllocations: AccountAllocation[]
    ): Observable<IGenericResponse<AccountAllocation>> {
        // return getTestServiceError<AccountAllocation>(19, accountAllocations as AccountAllocation[], 'Accountlistid');

        return this.http.put<IGenericResponse<AccountAllocation>>(this.uri, {
            AccountAllocationList: accountAllocations
        });
    }
    getFacilityAllocations(): Observable<FacilityAllocation[]> {
        return this.http
            .get<FacilityAllocation[]>(this.facilityAllocationsUri)
            .pipe(
                map(allocations =>
                    allocations.map(x => ({
                        ...x,
                        // id: `${x.Costcenterid}${x.Ratecode}`
                        id: x.CCratecodedesc
                    }))
                )
            );
    }
    putFacilityAllocations(
        facilityAllocations: FacilityAllocation[]
    ): Observable<IGenericResponse<FacilityAllocation>> {
        this.log.verbose({
            type: 'AccountAllocationsService:putFacilityAllocations',
            facilityAllocations
        });
        // return getTestServiceError<FacilityAllocation>(19, facilityAllocations as FacilityAllocation[], 'id');

        return this.http
            .put<IGenericResponse<FacilityAllocation>>(
                this.facilityAllocationsUri,
                {
                    FacilityAllocationList: facilityAllocations
                }
            )
            .pipe(
                map(allocations => ({
                    ...allocations,
                    Items: allocations.Items.map(x => ({
                        ...x,
                        // id: `${x.Costcenterid}${x.Ratecode}`
                        id: x.CCratecodedesc
                    }))
                }))
            );
    }
    getFacilityAllocationTypes(): Observable<SelectItem[]> {
        return this.http
            .get<
                {
                    Facilityallocationtypeid: number;
                    FacilityAllocationtype: string;
                    IsActive: boolean;
                }[]
            >(this.facilityAllocationTypeUri)
            .pipe(
                map(resp => resp.filter(x => x.IsActive)),
                map(resp =>
                    resp.map(x => ({
                        label: x.FacilityAllocationtype,
                        value: x.Facilityallocationtypeid
                    }))
                )
            );
    }
    getAccountPostingTypes(): Observable<AccountPostingType[]> {
        return this.http
            .get<any[]>(this.accountPostingTypeUri)
            .pipe(map(res => res.map(x => this.mapPostingType(x))));
    }
    putAccountPostingTypes(
        postingTypes: AccountPostingType[]
    ): Observable<IGenericResponse<AccountPostingType>> {
        // return getTestServiceError<AccountPostingType>(19, postingTypes as AccountPostingType[], 'PostingType');

        return this.http
            .put<IGenericResponse<any>>(this.accountPostingTypeUri, {
                AccountPostingTypeList: postingTypes.map(x => ({
                    Accountpostingtype: x.PostingType,
                    Accountlistid: x.ListID,
                    Defaultitem: x.Defaultitem
                }))
            })
            .pipe(
                map(resp => ({
                    ...resp,
                    Items: resp.Items.map(x => ({
                        ...this.mapPostingType(x),
                        Status: {
                            StatusCode:
                                x && x.Status
                                    ? x.Status.StatusCode
                                    : ResponseStatus.Success,
                            Message: x && x.Status ? x.Status.Message : ''
                        }
                    }))
                }))
            );
    }

    private mapPostingType(item: any): AccountPostingType {
        return {
            ...item,
            PostingType: item.Accountpostingtype,
            Name: item.Accountpostingname,
            AccountType: item.Accounttype,
            ListID: item.Accountlistid,
            Description: item.Accountpostingtypedesc,
            Defaultitem: item.Defaultitem,
            Status: { StatusCode: 0, Message: '' }
            // id: Guid.newGuid()
        };
    }
}
